const keyMirror = require('keymirror');

export const EVENTS = keyMirror({
    GET_POINTS_DATA: null,
    GET_POINTS_DATA_FAILED: null,
    HIDE_POINTS_ON_DIFFERENT_CURRENCY: null,
    OPEN_POINTS_CARD: null,
    CLOSE_POINTS_CARD: null,
    USER_APPLIED_POINTS_TO_PAYMENT: null,
});